import React from 'react';
import { signInAnonymously, signInWithPopup } from 'firebase/auth'
import { auth, provider } from '../../database/firebase';
import { db } from '../../database/firebase';
import { doc, getDoc } from 'firebase/firestore'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { accountInit } from '../../database/accountInit';


const AnonymousSignIn = () => {
  const anonymousSignIn = async () => {
    const auth = getAuth();
    signInAnonymously(auth)
      .then(async () => {
        const docRef = doc(db, 'users', auth.currentUser.uid)
        const docSnap = await getDoc(docRef)
        if (!docSnap.exists()) {
          await accountInit();
          console.log('new account')
        } else {
          console.log('not a new account')
        }
        window.location.assign('/');
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode);
        console.log(errorMessage);
      });
  }
  return (
    <>
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        < button style={{ height: '50px', fontSize: '1em', width: '240px' }} onClick={anonymousSignIn}>匿名で始める</button >
      </div >
    </>
  )
}

export default AnonymousSignIn
